import type { FC } from 'react';
import { Route, Routes } from 'react-router';

import InitializePasswordPage from './_pages/InitializePasswordPage';
import LoginPage from './_pages/LoginPage';
import ResetForgotPasswordPage from './_pages/ResetForgotPasswordPage';

export const AuthenticationRoutes: FC = () => {
  return (
    <Routes>
      <Route index element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetForgotPasswordPage />} />
      <Route path="/initialize-password" element={<InitializePasswordPage />} />
    </Routes>
  );
};
